import type { TNumber } from '~/components/UiNumbers/UiNumbers.types'
import type { IBsNumberFields } from '@/types/contentful'

export const adaptNumbers = (numbers: IBsNumberFields[]): TNumber[] => {
  return numbers.map((item: IBsNumberFields) => ({
    number: item.header,
    text: item.description,
  }))
}
